const GPX_INGEST_URL = process.env.API_URL + '/health/gpx';
const OPTIONS = { headers: { 'Content-Type': 'multipart/form-data' } };

const uploadGpxForUser = (context, file) => {
  return new Promise((resolve, reject) => {
    context.$http.post(GPX_INGEST_URL, formData(file), OPTIONS)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const formData = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

export default {
  uploadGpxForUser
};



// WEBPACK FOOTER //
// ./src/brand/health/api/GpxIngest/index.js